import { put, call, take, fork } from 'redux-saga/effects'
import { LLMFinalToolService } from '../../api/llm'
import { llmFinalToolSuccess } from '../../reducers/llm/action'
import { FINAL_TOOL } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* finalToolFlow(payload) {
  try {
    const {
      courseId,
      languageCode,
      chatId,
      isMobile,
      courseCode,
      callback,
    } = payload

    const response = yield call(
      LLMFinalToolService,
      courseId,
      languageCode,
      chatId,
      isMobile,
      courseCode,
    )

    yield put(llmFinalToolSuccess(response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* finalToolWatcher() {
  while (true) {
    const action = yield take(FINAL_TOOL)
    const { payload } = action

    yield fork(generalSaga, finalToolFlow, payload, false)
  }
}
